/**
 * This file is part of VILLASweb.
 *
 * VILLASweb is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * VILLASweb is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with VILLASweb. If not, see <http://www.gnu.org/licenses/>.
 ******************************************************************************/

import React from "react";
import ReactDOM from "react-dom";
import Router from "./router";
import { Provider } from "react-redux";
import {store} from "./store/index";
import "bootstrap/dist/css/bootstrap.css";
import "./styles/index.css";

const loadEnv = () =>
  fetch("/env.js")
    .then(res => res.text())
    .then(js => {
      eval(js);
    });

loadEnv().then(() => {
  console.log("Runtime env brand:", window._env_?.FRONTEND_BRANDING);
  const branding = new Branding(window._env_?.FRONTEND_BRANDING || "villasweb");

  ReactDOM.render(
  <Provider store={store}>
    <Router />
  </Provider>,
  document.getElementById("root")
  );
});